import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import GlobalContext from "../context/GlobalContext";

function NavBar() {
  const { userDetails, setUserDetails, authenticated, setAuthenticated } =
    useContext(GlobalContext);
  function handleLogout(e) {
    e.preventDefault();
    localStorage.clear();
    window.location.href = "/account/login";
  }

  useEffect(() => {
    if (localStorage.getItem("user_info") != null) {
      setUserDetails(JSON.parse(localStorage.getItem("user_info")));
      if (userDetails) setAuthenticated(true);
    }
  }, []);

  return (
    <div className="navBar">
      <a href="/">
        <h1>Slottaby</h1>
      </a>
      <div className="navButtons">
        {authenticated ? (
          <>
            {userDetails.result ? (
              <>
                <img
                  src={userDetails.result.profilePicture}
                  alt="profilePic"
                  className="profilePicture"
                ></img>
                <p>
                  <strong>
                    {userDetails.result.role === "admin" ? (
                      <Link to="/account/adminPanel">
                        {userDetails.result.firstName +
                          " " +
                          userDetails.result.lastName.substring(0, 1)}
                      </Link>
                    ) : (
                      userDetails.result.firstName +
                      " " +
                      userDetails.result.lastName.substring(0, 1)
                    )}
                  </strong>
                </p>
              </>
            ) : (
              <i className="fas fa-user-profile"></i>
            )}

            <Link onClick={handleLogout}>
              <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2 ">
                logout
              </span>
            </Link>
          </>
        ) : (
          <>
            <Link to="/account/login">
              <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2 ">
                login
              </span>
            </Link>
            <Link to="/account/register">
              <span className="material-icons-outlined cursor-pointer text-gray-600 mx-2 ">
                app_registration
              </span>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export default NavBar;
